<template>
  <div>
    <div @click="asdji">
      <i class="el-icon-back"></i>
      <span class="zi">返回</span>
      <el-divider direction="vertical"></el-divider>
      <span class="zi">添加账号</span>
    </div>
    <div class="tip">
      <div >
        <el-radio-group style="margin-top: 30px" v-model="radio1" @change="RadioChange">
          <el-radio-button label="企业微信账号"></el-radio-button>
          <el-radio-button label="AD账号"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="table" v-if="table1 == 1 ">
              <el-form ref="form" >
                <el-form-item prop="text">
                  <div class="tr du">
                    <div class="dsu"><i style="color: #ee2928;margin-right: 6px">*</i> 姓名:</div>
                    <div >
                      <el-input
                        @focus="addStaff"
                        style="margin-left: 12px;width: 390px"
                        type="text"
                        placeholder="请选择员工姓名"
                        v-model="staff_name"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </el-form-item>
                <el-form-item prop="text">
                  <div class="tr du">
                    <div class="dsu">
<!--                      <i style="color: #ee2928;margin-right: 6px">*</i> -->
                      企业微信邮箱: </div>
                    <div >
                      <el-input
                        style="margin-left: 12px;width: 390px"
                        type="text"
                        placeholder="请输入企业微信邮箱"
                        v-model="text1"
                        show-word-limit
                      >
                      </el-input>
                    </div>
                  </div>
                </el-form-item>
              </el-form>
      <!--        <hr />-->
              <div class="njhu">
                <el-button type="info" plain style="width: 72px;"  @click="asdji">取消</el-button>
                <el-button style="width: 72px;"  type="primary" @click="redact02">保存</el-button>
              </div>
            </div>

      <div class="table" v-if="table1 == 2 ">
        <el-form ref="form" >
          <el-form-item prop="text">
            <div class="tr du">
              <div class="dsu"><i style="color: #ee2928;margin-right: 6px">*</i> 姓名:</div>
              <div >
                <el-input
                  style="margin-left: 12px;width: 390px"
                  type="text"
                  placeholder="请输入姓名"
                  v-model="text"
                  maxlength="15"
                  show-word-limit
                >
                </el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="text">
            <div class="tr du">
              <div class="dsu"><i style="color: #ee2928;margin-right: 6px">*</i> AD邮箱: </div>
              <div >
                <el-input
                  style="margin-left: 12px;width: 390px"
                  type="text"
                  placeholder="请输入AD邮箱"
                  v-model="text1"
                  show-word-limit
                >
                </el-input>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <br />
        <div style="display: flex;margin-left: 56px">
          <div class="dsu" style="margin-left: 30px"><i style="color: #ee2928;margin-right: 6px">*</i> 部门:</div>
          <button class="wqeyu" @click="departmentShow">选择</button>
          <div >
            <div class="bi">
              <el-tag
                v-for="tag in edit_department"
                :key="tag.value"
                :type="tag.type">
                <img src="../../assets/images/zuzhi.png" width="14px;" height="14px;">
                {{ tag.label }}
              </el-tag>
            </div>
          </div>
        </div>
        <hr />
        <div class="njhu">
          <el-button type="info" plain style="width: 72px;"  @click="asdji">取消</el-button>
          <el-button style="width: 72px;"  type="primary" @click="redact01">保存</el-button>
        </div>
      </div>
    </div>
    <!--    <p class="center">-->
    <!--        <el-button type="info" plain @click="$router.go(-1)">取消</el-button>-->
    <!--        <el-button style="width: 72px;" type="primary" @click="editPermission">保存</el-button>-->
    <!--      </p>-->
    <department
      :isShow="isDepartmentDialog"
      @check-user="checkUser1"
      :isMultiple="false"
      :checkeds="checkedEmployees"
      v-if="isDepartmentDialog"
      :title="title"
    ></department>
    <Departmentatde
      :isShow="departmentShow2"
      @check-user="checkUser"
      v-if="departmentShow2"
      :checkeds="edit_department"
    ></Departmentatde>
  </div>
</template>
<script>
import Department from '../../components/department'
import Departmentatde from '../../components/departmentat.vue'
export default {
  components: {
    Departmentatde,
    Department
  },
  data() {
    return {
      radio1: '企业微信账号',
      table1: 1,
      isDepartmentDialog: false,
      checkedEmployees: [],
      staff_name: [],
      text: '',
      text1: '',
      departmentShow2: false,
      loading: false,
      departid: [],
      isShow: false,
      // rules: {
      //   radio: [{ required: true, message: '请选择删除时间！', trigger: 'blur' }],
      //   number: [{ required: true, message: '请输入删除客户数量', trigger: 'blur' }, { pattern: /^[1-9|^\\.]/, message: '删除客户数量不能为0和负数' }]
      //   // text: [{ required: true, message: '请输入字段名称', trigger: 'blur' }]
      // },
      edit_department: []
    }
  },
  mounted() {
    this.loading = true
  },
  watch: {
  },
  methods: {
    RadioChange() {
      if (this.radio1 === 'AD账号') {
        this.text = ''
        this.text1 = ''
        this.edit_department = ''
        this.table1 = 2
      } else {
        this.text = ''
        this.text1 = ''
        this.table1 = 1
      }
    },
    addStaff() {
      this.isDepartmentDialog = true
    },
    asdji() {
      this.$router.go(-1)
    },
    checkUser1(checkedEmployee) {
      if (checkedEmployee === '') {
        this.isDepartmentDialog = false
        return false
      }
      if (checkedEmployee && checkedEmployee.length) {
        this.sendName = checkedEmployee[0].name
        this.sendOutName = checkedEmployee[0].id
        this.isDepartmentDialog = false
        this.staff_name = this.sendName
        // this.$api.post('api/system/manage/staff/add', {
        //   user_id: this.sendOutName
        // })
        //   .then(res => {
        //     const arr = res
        //     if (arr.length === 0) {
        //       this.$message.success('添加成功')
        //     } else {
        //       this.$message.error('添加失败')
        //     }
        //     this.getList()
        //   })
      } else {
        this.isDepartmentDialog = false
      }
    },
    checkUser(depaert_list) {
      console.log('aaaaaaaaaaaa', depaert_list)
      this.edit_department = depaert_list
      this.departmentShow2 = false
    },
    // redact01() {
    //   this.show = true
    //   this.disabled = true
    //   this.$api.post('/api/system/sensitive/add/rule', {
    //     delete_time: this.form.radio,
    //     user_number: this.form.number,
    //     is_direct_leader: this.form2.radio,
    //     is_custom_direct_leader: this.form2.text,
    //     content: this.sendOutName
    //   }).then(res => {
    //     this.getDetail()
    //     this.$router.go(0)
    //     // this.$router.replace({ path: '/control/operationLog' })
    //   })
    // },
    redact01() {
      this.edit_department.forEach(k => {
        this.departid.push(k.value)
      })
      console.log(this.departid)
      this.$confirm('是否确认保存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      })
        .then(() => {
          this.$api
            .post('/api/system/manage/staff/add2', {
              user_name: this.text,
              email: this.text1,
              department: this.departid
            })
            .then(async () => {
              this.$message.success('成功！')
              this.$router.go(-1)
            })
        })
        .catch(() => {})
    },
    redact02() {
      this.$confirm('是否确认保存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      })
        .then(() => {
          this.$api.post('api/system/manage/staff/add', {
            user_id: this.sendOutName,
            email: this.text1
          })
            .then(async () => {
              this.$message.success('成功！')
              this.$router.go(-1)
            })
        })
        .catch(() => {})
    },
    departmentShow() {
      this.departmentShow2 = true
    },
    getDepartlist() {
      this.$api
        .post('/api/system/manage/department/list', {
          department_id: this.aer
        }).then(res => {
        let arr = []
        arr = res.data
        arr.forEach(k => {
          this.edit_department.push({ label: k.name, value: k.department_id })
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-icon-back{
  font-size: 16px;
}
.zi{
  height: 16px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.85);
  opacity: 1;
}
::v-deep .el-divider--vertical{
  font-size: 16px;
}
.tip {
  height: 56.25rem;
  //text-align: right;
  margin-top: 20px;
  padding-top: 0;
  padding-bottom: 20px;
  padding-left: 24px;
  padding-right: 24px;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgb(2 47 50 / 8%);
  opacity: 1;
  font-size: 14px;
  border-radius: 2px;
}
.table {
  margin-top: 20px;
  .tr {
    width:100%;
    word-wrap: break-word;
    word-break: normal;
    text-align: left;
    border-bottom: 1px solid #d8dce6;
    .dsu{
      width: 130px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
    .fsdf{
      width: 158px;
    }
    .asdas{
      width: auto;
      height: auto;
      padding: 10px;
      padding-left: 27px;
      .wqeyu{
        font-size: 15px;
        color: #204A9E;
        font-weight: 500;
        border: none;
        background: none;
      }
      .wqeyu01{
        font-size: 15px;
        color: #204A9E;
        font-weight: 500;
        border: none;
        background: none;
        cursor:pointer;
      }
      .wqeyu01:hover{
        border-bottom: 1px solid #204A9E;
      }
    }
    .asdas01{
      height: auto;
    }
    .td {
      display: flex;
      height: auto;
      border-left: 1px solid #d8dce6;
      padding-left: 20px;
    }
  }
  .du{
    display: flex;
    padding-top: 30px;
    padding-bottom: 20px;
    align-items: center;
  }
}
.njhu{
  width: 100%;
  display: flex;
  height: auto;
  justify-content: center;
  align-items: center;
  margin-top: 4.5rem;
}
.ding01{
  position: relative;
  left: -3.5rem;
  width: 14px;
  height: 14px;
}
::v-deep .table .tr .asdas .wqeyu:disabled {
  color: #C0C4CC;
}
.el-tag--plain {
  background-color: #fff;
  border-color: #D8DCE6;
  color: #606266;
  margin-right: 10px;
  margin-bottom: 10px;
}
::v-deep .el-tag--plain .el-tag__close {
  color: #D8DCE6;
}
.eqweq{
  display: flex;
  width: 100%;
  padding-top: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #D8DCE6;
  .qewe{
    width: 98px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: auto;
  }
  .asdas{
    // width: 65px;
    height: auto;
  }
  .qwedsdd{
    width: auto;
    height: auto;
    display: flex;
    text-align: left;
    word-wrap: break-word;
    word-break: normal;
  }
  .wqeyu{
    font-size: 15px;
    color: #204A9E;
    font-weight: 500;
    border: none;
    background: none;
  }
  .wqeyu:hover{
    font-size: 17px;
    color: #204A9E;
    opacity: 0.8;
  }
  .wqeyu:disabled {
    color: #C0C4CC;
  }
}
.ding02 {
  width: 12px;
  height: 12px;
}
::v-deep .el-input-group__append{
  font-size: 16px;
  color: #fff;
  background: #D8DCE6;
}
::v-deep .el-radio__input.is-disabled+span.el-radio__label{
  padding-left: 8px;
}
::v-deep.el-form-item__error {
  color: #F56C6C;
  position: relative;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 70px;
  left: 125px;
}
::v-deep .el-form-item__error {
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 67px;
  left: 125px;
}
.imsdsg{
  position: relative;
  top: 1px;
}
::v-deep .el-tag--plain .el-tag__close:hover{
  background: #204A9E;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
::v-deep input[type='number'] {
  -moz-appearance: textfield !important;
}
.wqeyu{
  font-size: 15px;
  color: #204A9E;
  font-weight: 500;
  border: none;
  background: none;
}
.wqeyu:hover{
  font-size: 17px;
  color: #204A9E;
  opacity: 0.8;
}
.wqeyu:disabled {
  color: #C0C4CC;
}
.bi{
  // width:90%;
  height:auto;
  max-height: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.el-tag{
  height: 26px;
  padding: 3px 5px;
  line-height: 16px;
  background: white;
  margin-bottom: 10px;
  margin-right: 10px;
  color:#606266;
  border: 1px solid #D8DCE6;
  opacity: 1;
  border-radius: 2px;
  img {
    position: relative;
    top: 2px;
  }
}
::v-deep .el-tag .el-tag__close{
  color: #606266;
}
::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner{
  border-left: 1px solid #204a9e;
  background-color: #204a9e;
  border-color: #204a9e;
}
</style>
